var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#121214"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.502 14.567 6.797-7.9h-1.61l-5.902 6.859-4.713-6.86H6.638l7.127 10.373-7.127 8.285h1.61l6.232-7.244 4.977 7.244h5.437zm-2.205 2.564-.723-1.033-5.745-8.22h2.473l4.637 6.634.722 1.033 6.028 8.621h-2.474z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Twitter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.637 6.667h18.256v18.667H6.637z"
  })))));
};
export default SvgTwitter;